import { handleActions } from 'redux-actions'

import * as muteAudioActions from '../actions/muteAudio'

const defaultValue = false

export default handleActions(
  {
    [muteAudioActions.onMuteAudioProgressStateUpdate.toString()](
      state,
      action: ReturnType<typeof muteAudioActions.onMuteAudioProgressStateUpdate>
    ) {
      return action.payload
    },
  },
  defaultValue
)
